<div class="search-input-wrapper">
  <span class="material-icons search-icon" aria-hidden="true">search</span>

  <input
    #inputElement
    type="text"
    class="search-input"
    [placeholder]="placeholder"
    [value]="value"
    [disabled]="disabled"
    (input)="onInput($event)"
    (blur)="onBlur()"
    (keyup)="onKeyUp($event)"
    [attr.aria-label]="placeholder"
  />

  @if (showClearButton && value) {
  <button
    type="button"
    class="clear-search-btn"
    (click)="onClear()"
    [attr.aria-label]="'Clear search'"
  >
    <span class="material-icons" aria-hidden="true">close</span>
  </button>
  }
</div>
